export default "__VITE_ASSET__5a7ce330__"